"use client";

import { useEffect } from "react";

/** Registriert den Service Worker fuer die Installierbarkeit (Icons/Manifest) -
 * cached bewusst keine Seiten- oder API-Antworten, siehe public/sw.js. */
export function PwaRegister() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Installierbarkeit ist ein Zusatz, kein kritischer Pfad - stiller Fallback.
    });
  }, []);

  return null;
}
